// extracted by mini-css-extract-plugin
module.exports = {"specialistsRadio":"AvVc1","specialistsRadio_radio-label":"EvxiB"};